import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

import { DialogModule } from '../dialog/dialog.module';
import { ButtonModule } from '../button/button.module';
import { MaterialUiModule } from '../../material-ui-module/material-ui.module';

import { ConfirmDialogData } from '@cpd-app/core-module/models';

let nextTitleId = 0;

@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, MaterialUiModule]
})
export class ConfirmDialogComponent implements OnInit {
  public readonly titleId = `cpd-confirm-dialog-title-${nextTitleId++}`;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ConfirmDialogData,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    this.dialogRef.addPanelClass('confirm-dialog');
    this.dialogRef.updateSize('610px');
  }

  public ngOnInit(): void {
    if (!this.data) {
      this.data = {
        title: 'Confirmation',
        message: 'Are you sure?',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        icon: 'warning',
        confirmFn: () => {
          return;
        }
      };
    }

    /*
     * The dialog had no accessible name: its title was a plain div and none
     * of its nine callers passed ariaLabelledBy. Naming it here covers all of
     * them. This is what MatDialogTitle does; the directive itself is not
     * used because the global .mat-mdc-dialog-title rule paints a primary
     * band behind it. A caller's own ariaLabel still wins, as Material has it.
     * Deferred a tick, as the directive does, so the container's binding is
     * not changed while it is being checked.
     */
    void Promise.resolve().then(() =>
      this.dialogRef._containerInstance?._addAriaLabelledBy?.(this.titleId)
    );
  }
}
